import { Settings as SettingsIcon } from 'lucide-react';

import { AppShell, Breadcrumbs } from '@/components/landing/AppShell';

/**
 * Placeholder route so the sidebar Settings entry resolves cleanly. Full
 * workspace settings (default board, voice, narration tone, API base
 * override, etc.) lands later.
 */
export default function SettingsPage() {
  return (
    <AppShell activeNav="settings">
      <div className="mx-auto flex w-full max-w-[1100px] flex-col px-8 pt-6 pb-16">
        <Breadcrumbs
          items={[
            { label: 'Workspace', href: '/lesson-packs' },
            { label: 'Settings' },
          ]}
        />

        <div className="mt-3">
          <h1 className="text-[26px] font-semibold tracking-tight text-fg">
            Settings
          </h1>
          <p className="mt-1 text-sm text-fg-muted">
            Workspace preferences, defaults, and integrations.
          </p>
        </div>

        <div className="mt-10 flex flex-col items-center justify-center rounded-xl border-2 border-dashed border-border bg-bg-panel/50 py-16 text-center">
          <span className="grid h-14 w-14 place-items-center rounded-xl bg-accent-soft text-accent">
            <SettingsIcon size={24} />
          </span>
          <h3 className="mt-4 text-base font-semibold text-fg">Coming soon</h3>
          <p className="mt-1.5 max-w-sm text-[13px] text-fg-muted">
            Workspace-wide defaults (board, narration voice, default font,
            etc.) will live here.
          </p>
        </div>
      </div>
    </AppShell>
  );
}
